export interface Counter {
  total: number;
  active: number;
  disabled: number;
}

export enum AuthTypeValues {
  OAUTH2 = 0,
  ENTRAID = 1,
  OPENIDCONNECT = 2,
}

export type AuthenticationVersion = 'api' | 'employee';
export type DialogKey = 'add' | 'delete' | 'delete-multiple' | 'client-secret';

export const StatusType = {
  Active: true,
  Disabled: false,
} as const;

export const DEFAULT_AUTH_VALUES: AuthInputValues = {
  auth_endpoint: '',
  token_endpoint: '',
  clientId: '',
  client_secret: '',
  grant_type: '',
  scope: '',
  ext_userId_claim: '',
  self_discovery_endpoint: '',
  logout_endpoint: '',
  tenantId: '',
} as const;

export interface AuthInputValues {
  auth_endpoint: string;
  token_endpoint: string;
  logout_endpoint?: string;
  clientId: string;
  grant_type: string;
  scope: string;
  client_secret?: string;
  ext_userId_claim?: string;
  self_discovery_endpoint?: string;
  tenantId?: string;
}

export interface CreateAuthenticationConfigurationParams {
  organizationId: string;
  authType: AuthTypeValues | undefined;
  authConfigValues: AuthInputValues;
  secretName: string;
}

export interface UpdateOrganizationParams {
  organizationAuthType: AuthTypeValues | undefined;
  organizationName: string;
  organizationStatus: boolean;
  organizationPartnerIds: string[] | undefined;
  organizationId: string;
}

export interface IntegrationParams {
  integrationAuthType: AuthTypeValues;
  clientSecretName: string;
  enabled: boolean;
  integrationName: string;
  integrationId: string;
}
